export const PARTNER_LOGIN = 'partner/login';
export const PRODUCT_LIST = 'product/list';
export const ADD_PRODUCT = 'product/saveProduct';
export const GET_PRODUCT = 'product/productDetails';
export const DELETE_PRODUCT = 'product/deleteProduct';
export const CATEGORT_LIST = 'category/list';
export const CATEGORT_SAVE = 'category/saveCategory';
export const GET_CATEGORY = 'category/categoryDetails';
export const DELETE_CATEGORY = 'category/deleteCategory';
export const UNIT_LIST = 'unit/list';
export const CUSTOMER_LIST = 'customer/list';
export const GET_CUSTOMER_LIST = 'customer/getCustomerList';
export const SAVE_CUSTOMER = 'customer/saveCustomer';
export const UPDATE_BILLING_DETAILS = 'customer/updateCustomer';
export const GET_CUSTOMER = 'customer/getCustomer';
export const GET_STATES = 'state/list';
export const SAVE_UNIT = 'unit/saveUnit';
export const VENDOR_LIST = 'customer/vendorList';
export const PURCHASE_ORDER = 'purchase/order';
export const GET_PURCHASE_NUMBER = 'purchase/getPurchaseNumber';
export const UPDATE_PURCHASE_ORDER = 'purchase/updatePurchaseOrder';
export const PURCHASE_ORDER_LIST = 'purchase/orderList';
export const PURCHASE_ORDER_DETAILS = 'purchase/orderDetails';
export const ORDER_ACTIONS = 'purchase/approveOrder';
export const CONVERT_TO_BILL = 'purchase/purchaseConvertToBill';
export const COMPANY_DETAILS = 'company/getDetails';
export const SAVE_COMPANY_DETAILS = 'company/saveDetails';
export const SAVE_LOGO = 'company/uploadFiles';
export const GET_LOGO = 'company/getLogo';
export const INVOICE_ORDER = 'invoice/saveOrder';
export const GET_INVOICE_NUMBER = 'invoice/getInvoiceNumber';
export const UPDATE_ORDER = 'invoice/updateInvoiceOrder';
export const GET_UNPAID_INVOICES = 'invoice/unpaidInvoicesDetails';
export const INVOICES_LIST = 'invoice/getDetails';
export const INVOICES_ORDER_DETAILS = 'invoice/invoiceOrderDetails';
export const CHANGE_PASS = 'profile/changePassword';
export const UPDATE_PROFILE = 'profile/updateProfile';
export const GET_PROFILE = 'profile/profileDetails';
export const PAYMENT_LIST = 'payment/paymentDetails';
export const GET_PAYMENT_DETAILS = 'payment/getPaymetDetails';
export const GET_PAYMENT_NUMBER = 'payment/getPaymentNumber';
export const MAKE_PAYMENT = 'payment/updatePayment';
export const MAKE_VENDOR_PAYMENT = 'payment/updateVendorPayment';
export const SAVE_EXPENSE = 'expense/saveExpense';
export const GET_EXPENSE_NUMBER = 'expense/getExpenseNumber';
export const GET_EXPENSE = 'expense/expenceList';
export const EXPENSE_ORDER = 'expense/getExpenseById';
export const GET_EXPENSE_DETAILS = 'expense/getExpenseDetails';
export const DASHBOARD = 'dashboard';
export const GET_PARTNER = 'partner/getPartnerDetails';
export const GET_BILL_NUMBER = 'bill/getBillNumber';
export const UNPAID_BILL_ORDERS = 'bill/unpaidBillDetails';
export const SAVE_BILL = 'bill/saveBill';
export const UPDATE_BILL = 'bill/updateBill';
export const GET_BILLS = 'bill/getBill';
export const BILL_DETAILS = 'bill/billDetails';
export const GET_CHART_DATA = 'invoiceChart';
export const GET_FINANCIAL_MONTHS = 'getFinancialMonth';
export const DOWNLOAD_INVOICE_REPORT = 'report/invoiceExcel';
export const DOWNLOAD_PRODUCT_REPORT = 'report/productExcel';
export const GET_QUOTE_NUMBER = 'quote/getQuoteNumber';
export const SAVE_QUOTE = 'quote/saveQuote';
export const QUOTE_LIST = 'quote/quoteDetails';
export const QUOTE_DETAILS = 'quote/getQuoteDetails';
export const CONVERT_TO_INVOICE = 'quote/quoteConvertToInvoice';
export const UPDATE_QUOTE = 'quote/updateQuote';
export const SAVE_CREDIT_NOTE = 'creditnote/saveCreditNote';
export const GET_CREDITNOTE_NUMBER = 'creditnote/getCreditnoteNumber';
export const CREDIT_NOTES = 'creditnote/creditNoteList';
export const GET_INVOICES = 'invoice/getInvoice';
export const CREDIT_NOTE_DETAILS = 'creditnote/creditNoteDetails';
export const UPDATE_CREDIT_NOTE = 'creditnote/updateCreditNote';

 